import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'

// Mirrors `industryOptions` in the sanity-studio repo
// (schemaTypes/constants.ts), keyed by the stored value.
export const INDUSTRY_LABELS: Record<string, MessageDescriptor> =
  defineMessages({
    'software-development': {
      id: 'website.customers.industry.softwareDevelopment',
      defaultMessage: 'Software Development',
    },
    'technology-information-and-internet': {
      id: 'website.customers.industry.technologyAndInternet',
      defaultMessage: 'Technology & Internet',
    },
    fintech: {
      id: 'website.customers.industry.fintech',
      defaultMessage: 'Fintech',
    },
    'financial-services': {
      id: 'website.customers.industry.financialServices',
      defaultMessage: 'Financial Services & Banking',
    },
    accounting: {
      id: 'website.customers.industry.accounting',
      defaultMessage: 'Accounting',
    },
    consulting: {
      id: 'website.customers.industry.consulting',
      defaultMessage: 'Consulting',
    },
    'professional-services': {
      id: 'website.customers.industry.professionalServices',
      defaultMessage: 'Professional Services',
    },
    'engineering-and-construction': {
      id: 'website.customers.industry.engineeringAndConstruction',
      defaultMessage: 'Engineering & Construction',
    },
    manufacturing: {
      id: 'website.customers.industry.manufacturing',
      defaultMessage: 'Manufacturing',
    },
    'ecommerce-and-retail': {
      id: 'website.customers.industry.ecommerceAndRetail',
      defaultMessage: 'E-commerce & Retail',
    },
    'marketing-and-advertising': {
      id: 'website.customers.industry.marketingAndAdvertising',
      defaultMessage: 'Marketing & Advertising',
    },
    'media-and-entertainment': {
      id: 'website.customers.industry.mediaAndEntertainment',
      defaultMessage: 'Media & Entertainment',
    },
    'healthcare-and-life-sciences': {
      id: 'website.customers.industry.healthcareAndLifeSciences',
      defaultMessage: 'Healthcare & Life Sciences',
    },
    education: {
      id: 'website.customers.industry.education',
      defaultMessage: 'Education & EdTech',
    },
    'real-estate': {
      id: 'website.customers.industry.realEstate',
      defaultMessage: 'Real Estate',
    },
    legal: {
      id: 'website.customers.industry.legal',
      defaultMessage: 'Legal',
    },
    'hr-and-staffing': {
      id: 'website.customers.industry.hrAndStaffing',
      defaultMessage: 'HR & Staffing',
    },
    'logistics-and-transportation': {
      id: 'website.customers.industry.logisticsAndTransportation',
      defaultMessage: 'Logistics & Transportation',
    },
    'hospitality-and-travel': {
      id: 'website.customers.industry.hospitalityAndTravel',
      defaultMessage: 'Hospitality & Travel',
    },
    'non-profit': {
      id: 'website.customers.industry.nonProfit',
      defaultMessage: 'Non-profit',
    },
  })
